import { useState, type FormEvent } from 'react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { Button, Field, Modal, useReport, useToast } from '../ui/kit';

/** Everyone can change their own password. It signs them out everywhere, so they sign in again with the new one. */
export function ChangePassword({ onClose }: { onClose: () => void }) {
  const { logout } = useAuth();
  const toast = useToast();
  const report = useReport();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [busy, setBusy] = useState(false);
  const valid = current.length > 0 && next.length >= 10 && next === again;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    try {
      await api('/auth/change-password', { method: 'POST', body: { currentPassword: current, newPassword: next } });
      toast.ok('Password changed. Please sign in again with the new one.');
      await logout();
    } catch (err) {
      report(err);
      setBusy(false);
    }
  };

  return (
    <Modal open onClose={onClose} title="Change my password">
      <form className="stack" onSubmit={(e) => void submit(e)}>
        <Field id="cp-cur" label="Current password"><input id="cp-cur" className="input" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus /></Field>
        <Field id="cp-new" label="New password" hint="At least 10 characters, not your email name, not a common password">
          <input id="cp-new" className="input" type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} />
        </Field>
        <Field id="cp-again" label="New password again" error={again.length > 0 && next !== again ? 'The two do not match' : undefined}>
          <input id="cp-again" className="input" type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} />
        </Field>
        <div className="modal-foot">
          <Button type="button" onClick={onClose}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={!valid} loading={busy}>Change password</Button>
        </div>
      </form>
    </Modal>
  );
}
